import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchIcon from '@mui/icons-material/Search';

function OnTruckSearchForm(props) {

    return (
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px'}}>
                <label>Filter By</label>
            </Box>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px'}}>
                <FormControl sx = {{ mr: '0.6%', width: '15%' }}>
                    <LocalizationProvider dateAdapter = {AdapterMoment}>
                        <DatePicker
                            label = "Start Date"
                            name = 'startDate'
                            onChange = {(event) => props.handleDateChange(event, 'startDate')}
                            value = {props.startDate ? props.startDate : null}
                            renderInput = {(params) => <TextField {...params} />}
                            clearable = {true}
                        />
                    </LocalizationProvider>
                </FormControl>
                <FormControl sx = {{ mr: '0.6%', width: '15%' }}>
                    <LocalizationProvider dateAdapter = {AdapterMoment}>
                        <DatePicker
                            label = "End Date"
                            name = 'endDate'
                            onChange = {(event) => props.handleDateChange(event, 'endDate')}
                            value = {props.endDate ? props.endDate : null}
                            renderInput = {(params) => <TextField {...params} />}
                            clearable = {true}
                        />
                    </LocalizationProvider>
                </FormControl>
                <TextField 
                    name = 'truck_number'
                    label = 'Truck Number'
                    onChange = {(e) => props.setTruckNum(e.target.value)}
                    value = {props.truckNum}
                    sx = {{ width: '20%', mr: '0.6%' }}
                />
                 <TextField 
                    name = 'tracking_number'
                    label = 'Tracking Number'
                    onChange = {(e) => props.setTrackingNum(e.target.value)}
                    value = {props.trackingNum}
                    sx = {{ width: '20%', mr: '0.6%' }}
                />
                <Tooltip title = {"Clear filter."}  placement = 'right' >
                    <span>
                        <IconButton 
                            aria-label = "clearFilter" 
                            onClick = {props.clearSearch} 
                            sx = {{ mt: '5px', color: '#96605a' }}>
                            <FilterAltOffIcon />
                        </IconButton>
                    </span>
                </Tooltip>
                { props.packages.length > 0 ? 
                    <Button 
                        onClick = {props.exportPackages} 
                        endIcon = {<FileDownloadIcon />}
                        size = 'large'
                        sx = {{mt: '5px', fontWeight: 'bold', color: '#7d5265'}}
                    >
                    </Button>
            : null }
            </Box>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{flexDirection: 'row', mb: '10px'}}>
                <Button 
                    onClick = {props.getPackages}
                    size = 'large'
                    endIcon = {<SearchIcon />}
                    sx = {{mt: '5px', fontWeight: 'bold', color: '#7d5265'}}
                >
                    Search
                </Button>
            </Box>
        </Box>
    );
};

export default OnTruckSearchForm;